import { ISelectItem } from '@lla-platform/core/core-ui'

export enum TypeCode {
  NotSet = 'NotSet',
  Labor = 'Labor',
  Material = 'Material',
  Sublet = 'Sublet',
  OtherCharge = 'OtherCharge',
  Tax = 'Tax'
}

export const TypeCodeToLabel: { [key: string]: string } = {
  NotSet: 'Not Set',
  Labor: 'Labor',
  Material: 'Material',
  Sublet: 'Sublet',
  OtherCharge: 'Other Charge',
  Tax: 'Tax'
}

export const TypeCodeItems: ISelectItem[] = [
  {
    label: TypeCodeToLabel[TypeCode.NotSet],
    value: TypeCode.NotSet
  },
  {
    label: TypeCodeToLabel[TypeCode.Labor],
    value: TypeCode.Labor
  },
  {
    label: TypeCodeToLabel[TypeCode.Material],
    value: TypeCode.Material
  },
  {
    label: TypeCodeToLabel[TypeCode.Sublet],
    value: TypeCode.Sublet
  },
  {
    label: TypeCodeToLabel[TypeCode.OtherCharge],
    value: TypeCode.OtherCharge
  },
  {
    label: TypeCodeToLabel[TypeCode.Tax],
    value: TypeCode.Tax
  }
]
